import { ScrapReasons } from '../../../shared/types/operation';
import { Operation } from '../../types/sharedTypeImpl';


export const scrapReasonOptions = [
    ...ScrapReasons.map(it => it.label),
    'No reason given',
] as const;
export type ScrapReasonOption = typeof scrapReasonOptions[number];

export interface HandledScrapsFilters {
    queryFilters: {
        partDisplayName: string;
        orderNumber: string;
        startDate: Date | null;
        endDate: Date | null;
    };
    visibleReasons: ScrapReasonOption[];
}

const defaultScrapFilters: HandledScrapsFilters = {
    queryFilters: {
        partDisplayName: '',
        orderNumber: '',
        startDate: null,
        endDate: null,
    },
    visibleReasons: [...scrapReasonOptions],
};

export function getDefaultScrapFilters() {
    return structuredClone(defaultScrapFilters);
}

export function filterByScrapReason(operations: Operation[], visibleReasons: ScrapReasonOption[]) {
    if (visibleReasons.length === 0 || visibleReasons.length === scrapReasonOptions.length) {
        return operations;
    }

    const filteredOperations = operations.filter(it => {
        const scrapReason = it.scrapCloseForm?.scrapReason;
        if (scrapReason) {
            return scrapReason && visibleReasons.includes(scrapReason);
        } else {
            return visibleReasons.includes('No reason given');
        }
    });
    return filteredOperations;
}
